/**
 * @file Boutique du hub : uniquement les FX (auras autour du chat) et les feux d'artifice. Purement cosmetique.
 */
import { Component } from '../core/Component';
import { h, toggleClass } from '../core/dom';
import { uiHints } from '../core/feedback';
import { makeTabs, sheetHeader } from '../core/widgets';
import type { TabsHandle } from '../core/widgets';
import type { UiContext } from '../UiContext';
import { AuraPane } from './skins/AuraPane';
import { FireworkPane } from './skins/FireworkPane';

type TabId = 'fx' | 'fireworks';

export class HubShopScreen extends Component {
  private tabs!: TabsHandle<TabId>;
  private fx!: AuraPane;
  private fireworks!: FireworkPane;
  private fxPane!: HTMLElement;
  private fwPane!: HTMLElement;

  constructor(ctx: UiContext) {
    super(ctx, 'div', 'screen skins hubshop');
  }

  protected build(): void {
    const t = this.ctx.i18n;
    this.el.setAttribute('data-ui-block', '');
    this.fxPane = h('div', { class: 'pane pane-fx' });
    this.fwPane = h('div', { class: 'pane pane-fireworks' });
    this.fx = new AuraPane(this.ctx).mount(this.fxPane);
    this.fireworks = new FireworkPane(this.ctx).mount(this.fwPane);
    this.addDisposer(() => this.fx.destroy());
    this.addDisposer(() => this.fireworks.destroy());
    const initial = uiHints.hubShopTab ?? 'fx';
    uiHints.hubShopTab = null;
    this.tabs = makeTabs<TabId>(
      [
        { id: 'fx', label: t.t('hubshop.tab.fx') },
        { id: 'fireworks', label: t.t('hubshop.tab.fireworks') },
      ],
      initial,
      () => this.onTab(),
    );
    this.el.append(sheetHeader(this.ctx, t.t('hubshop.title')), this.tabs.el, h('div', { class: 'sheet-body' }, this.fxPane, this.fwPane));
    this.onTab();
  }

  private onTab(): void {
    const a = this.tabs.active();
    toggleClass(this.fxPane, 'active', a === 'fx');
    toggleClass(this.fwPane, 'active', a === 'fireworks');
    this.update(0);
  }

  override update(dt: number): void {
    if (this.tabs.active() === 'fx') this.fx.update(dt);
    else this.fireworks.update(dt);
  }
}
